<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
// NOTICE: KAPTION-INTEGRATION
import { downloadFile } from '@chatwoot/utils';
import { useAlert } from 'dashboard/composables';

import { useMessageContext } from '../provider.js';
import BaseAttachmentBubble from './BaseAttachment.vue';
import FileIcon from 'next/icon/FileIcon.vue';

const { attachments } = useMessageContext();

const { t } = useI18n();

const attachment = computed(() => {
  return attachments.value[0];
});

const url = computed(() => {
  return attachment.value.dataUrl;
});

const fileName = computed(() => {
  if (url.value) {
    const filename = url.value.substring(url.value.lastIndexOf('/') + 1);
    return filename || t('CONVERSATION.UNKNOWN_FILE_TYPE');
  }
  return t('CONVERSATION.UNKNOWN_FILE_TYPE');
});

const fileType = computed(() => {
  return fileName.value.split('.').pop();
});

// NOTICE: KAPTION-INTEGRATION
// A plain <a target="_blank"> opened documents inline instead of saving them —
// the Active Storage proxy serves PDFs with Content-Disposition: inline, so
// "Download" just rendered the PDF in a new tab (and a later browser "save"
// could lose the .pdf name, notably on Windows). Fetch the blob and force a
// named download instead — same pattern as the audio chips and GalleryView.
const downloadAttachment = async () => {
  try {
    await downloadFile({
      url: url.value,
      type: attachment.value.fileType || 'file',
      extension: attachment.value.extension || fileType.value,
    });
  } catch (error) {
    useAlert(t('GALLERY_VIEW.ERROR_DOWNLOADING'));
  }
};
</script>

<template>
  <BaseAttachmentBubble
    icon="i-teenyicons-user-circle-solid"
    icon-bg-color="bg-n-alpha-3 dark:bg-n-alpha-white"
    sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.FILE"
    :content="decodeURI(fileName)"
    :action="{
      onClick: downloadAttachment,
      label: $t('CONVERSATION.DOWNLOAD'),
    }"
  >
    <template #icon>
      <FileIcon :file-type="fileType" class="size-4" />
    </template>
  </BaseAttachmentBubble>
</template>
